<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Consulta de pacientes</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table
          pdfExportable
          ref="pacientes"
          :path="path"
          :createButton="false"
          :editButton="permiteEditar"
          :deleteButton="permiteEliminar"
          @editar="editar"
          @eliminar="eliminar"
          exportable
          :columns="[
            {
              display: 'Foto',
              value: 'url_imagen',
              image: true
            },
            {
              display: 'Nombre',
              value: 'nombre'
            },
            {
              display: 'Apellido',
              value: 'apellido'
            },
            {
              display: 'Identificación',
              value: 'identificacion'
            },
            {
              display: 'Sexo',
              value: 'sexo'
            },
            {
              display: 'Fecha de nacimiento',
              value: 'fecha_nacimiento'
            },
            {
              display: 'E-mail',
              value: 'email'
            },
            {
              display: 'Celular',
              value: 'celular'
            },
            {
              display: 'Teléfono',
              value: 'telefono'
            },
            {
              display: 'Dirección',
              value: 'direccion'
            },
            {
              display: 'Creación',
              value: 'created_at'
            },
            {
              display: 'Modificación',
              value: 'updated_at'
            },
            {
              display: 'Modificador',
              value: 'nombre_modificador'
            }
          ]"
        ></k-table>
      </div>
    </div>
    <modal name="paciente" scrollable width="80%" height="auto">
      <k-paciente
        v-model="selectedPaciente"
        @saved="saved"
        @cancelar="cancelar"
      ></k-paciente>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    permiteEditar: {
      type: Boolean,
      required: false,
      default: true
    },
    permiteEliminar: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function() {
    return {
      selectedPaciente: null,
      path: url + "/pacientes",
      selectedIndex: -1
    };
  },
  methods: {
    editar: function(row) {
      this.selectedPaciente = {
        imagen : row.url_imagen,
        celular : row.celular,
        id: row.id,
        nombre: row.nombre,
        apellido: row.apellido,
        fecha_nacimiento:
          row.fecha_nacimiento !== null ? new Date(row.fecha_nacimiento) : "",
        identificacion: row.identificacion,
        direccion: row.direccion,
        telefono: row.telefono,
        email: row.email,
        sexo: row.sexo,
        hipertension_arterial: row.hipertension_arterial === 'S',
        estado: row.estado,
        _method: "PUT",
        diabetes_mellitus: row.diabetes_mellitus === 'S',
        cirrosis_hepatica: row.cirrosis_hepatica === 'S',
        insuficiencia_renal: row.insuficiencia_renal === 'S',
        hipotiroidismo: row.hipotiroidismo === 'S',
        insuficiencia_cardiaca: row.insuficiencia_cardiaca === 'S',
        otras: row.otras === 'S',
        tratamiento: row.tratamiento,
        alergias: row.alergias
      };
      this.selectedIndex = this.$refs.pacientes.rows.indexOf(row);
      this.$modal.show("paciente");
    },
    eliminar: function(row) {
      let that = this;
      swal({
        title:
          "¿Está seguro de realizar la " +
          (row.estado === "A" ? "inactivación" : "activación") +
          " del paciente seleccionado?",
        text: "Se requiere de confirmación del usuario",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          axios
            .post(url + "/pacientes/" + row.id, {
              _method: "DELETE"
            })
            .then(function() {
              swal(
                "Se ha cambiado el estado del registro seleccionado.",
                "Realizado",
                "success"
              );
              that.$refs.pacientes.loadRows();
            })
            .catch(function() {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    saved: function(row) {
      this.$refs.pacientes.rows.splice(this.selectedIndex, 1, row);
      this.$modal.hide("paciente");
    },
    cancelar: function() {
      this.selectedIndex = -1;
      this.$modal.hide("paciente");
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/pacientes/ConsultaPacientes.vue